import $ from 'jquery';

export const getUrlParam = function (paramName, url) {
  var href = url || window.location.search.substr(1);
  var reg = new RegExp('(^|&)' + paramName + '=([^&]*)(&|$)');
  var matchResult = href.match(reg);
  var param = matchResult ? decodeURI(matchResult[2]) : '';
  return param;
};

/**
 * 檢查元素是否在窗口內，添加对应动画类，消失时移除动画类
 * @param {string} item .example
 * @param {string} clas fadeIn
 * @param {number} timeout 延迟时间，ms
 */
export function checkoutItemInWindow(item, clas, timeout = 0) {
  const itemTop = $(item).offset().top;
  const winScrollTop = $(window).scrollTop();
  //此官网适配方案下$(window).height()偏差很大，需要通过添加一个dom结构获取可视高度
  const visualHeight = $('.computed-height').height();
  if (winScrollTop + visualHeight > itemTop) {
    setTimeout(() => {
      $(item).addClass(clas);
    }, timeout);
  } else {
    $(item).removeClass(clas);
  }
}

// 检查设备
export function getDevice() {
  let ua = navigator.userAgent;
  let isWindowsPhone = /(?:Windows Phone)/.test(ua);
  let isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
  let isAndroid = /(?:Android)/.test(ua);
  let isFireFox = /(?:Firefox)/.test(ua);
  let isChrome = /(?:Chrome|CriOS)/.test(ua);
  let isTablet =
    /(?:iPad|PlayBook)/.test(ua) ||
    (isAndroid && !/(?:Mobile)/.test(ua)) ||
    (isFireFox && /(?:Tablet)/.test(ua));
  let isPhone = /(?:iPhone)/.test(ua) && !isTablet;
  let isPc = !isPhone && !isAndroid && !isSymbian;
  return {
    isTablet,
    isPhone,
    isAndroid,
    isPc,
    isChrome,
  };
}
